import { mediaQueryStyles, constants } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const modalCss = {
  root: {
    zIndex: 15,
  },
  scrollableBody: {
    flex: 1,
  },
  modalContentWrapper: {
    [breakpoint.downTo("xs")]: {
      maxWidth: 800,
    },
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
    [breakpoint.upTo(constants.breakpoints.BreakpointNames.xs)]: {
      button: {
        width: "100%",
      },
    },
  },
};
